export class CommonConstants {
    public static DateFormatString : string = "yyyy-MM-dd"
}